<template>
  <div v-if="item">
    <div v-if="forToday" class="w-full flex flex-col items-start gap-[10px] md:gap-[20px]">
      <div
        class="w-full h-[32px] flex items-center gap-[10px] py-[4px] px-[10px] rounded-[1000px] bg-[#EECCE7]"
      >
        <div class="PC_Body1-R text-[1F1D1F]">{{ item.shift_name }}</div>
        <div class="w-[1px] h-[26px] bg-[#B7B2B5]"></div>
        <div class="PC_Body1-R text-[1F1D1F]">
          {{ `${item.total_team} ทีม` }}
        </div>
      </div>
      <div
        v-for="(app, appIndex) in item.appointments"
        :key="appIndex"
        class="w-full flex items-center justify-start md:justify-center gap-[12px] md:gap-[20px] flex-wrap md:flex-nowrap"
      >
        <div class="min-w-[140px] PC_Body1-R text-[1F1D1F]">
          {{ `เวลา : ${app.start_time} - ${app.end_time}` }}
        </div>
        <div class="w-full flex items-center gap-[8px] md:gap-0 flex-wrap md:flex-nowrap">
          <div
            class="w-full h-[48px] flex items-center py-[6px] px-[10px] rounded-[6px] border-[1px] border-solid border-[#B7B2B5] bg-[#FBEFF8]"
          >
            <span class="PC_Body1-R text-[1F1D1F]">
              {{ app.shelter_name }}
            </span>
          </div>
          <div class="hidden md:block min-w-[20px] h-[2px] bg-[#B7B2B5]"></div>
          <div
            class="w-full h-[48px] flex items-center justify-between gap-[12px] py-[6px] px-[10px] rounded-[6px] border-[1px] border-solid border-[#9B237B]"
          >
            <span class="PC_Body1-R text-[1F1D1F]">
              {{ app.team_name }}
            </span>
            <div
              @click="() => openTeamInfoModal(app.team_id)"
              class="cursor-pointer"
            >
              <InfoIcon class="!text-[#9B237B] w-[20px] h-[20px]" />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="item.appointments.length <= 0"
        class="w-full flex items-center justify-center"
      >
        <span class="PC_Body1-R text-[1F1D1F]"> ไม่พบข้อมูล </span>
      </div>
    </div>
    <div v-else class="w-full flex flex-col items-start gap-[10px] md:gap-[20px]">
      <div class="PC_H3-SB text-[#1F1D1F]">
        {{ $formatDate5(item.date) }}
      </div>
      <div
        v-for="(row, rowIndex) in item.data"
        :key="rowIndex"
        class="w-full flex flex-col items-start gap-[10px] md:gap-[20px]"
      >
        <div
          class="w-full h-[32px] flex items-center gap-[10px] py-[4px] px-[10px] rounded-[1000px] bg-[#EECCE7]"
        >
          <div class="PC_Body1-R text-[1F1D1F]">{{ row.shift_name }}</div>
          <div class="w-[1px] h-[26px] bg-[#B7B2B5]"></div>
          <div class="PC_Body1-R text-[1F1D1F]">
            {{ `${row.total_team} ทีม` }}
          </div>
        </div>
        <div
          v-for="(app, appIndex) in row.appointments"
          :key="appIndex"
          class="w-full flex items-center justify-start md:justify-center gap-[12px] md:gap-[20px] flex-wrap md:flex-nowrap"
        >
          <div class="min-w-[140px] PC_Body1-R text-[1F1D1F]">
            {{ `เวลา : ${app.start_time} - ${app.end_time}` }}
          </div>
          <div class="w-full flex items-center gap-[8px] md:gap-0 flex-wrap md:flex-nowrap">
            <div
              class="w-full h-[48px] flex items-center py-[6px] px-[10px] rounded-[6px] border-[1px] border-solid border-[#B7B2B5] bg-[#FBEFF8]"
            >
              <span class="PC_Body1-R text-[1F1D1F]">
                {{ app.shelter_name }}
              </span>
            </div>
            <div class="hidden md:block min-w-[20px] h-[2px] bg-[#B7B2B5]"></div>
            <div
              class="w-full h-[48px] flex items-center justify-between gap-[12px] py-[6px] px-[10px] rounded-[6px] border-[1px] border-solid border-[#9B237B]"
            >
              <span class="PC_Body1-R text-[1F1D1F]">
                {{ app.team_name }}
              </span>
              <div
                @click="() => openTeamInfoModal(app.team_id)"
                class="cursor-pointer"
              >
                <InfoIcon class="!text-[#9B237B] w-[20px] h-[20px]" />
              </div>
            </div>
          </div>
        </div>
         <div
        v-if="row.appointments.length <= 0"
        class="w-full flex items-center justify-center"
      >
        <span class="PC_Body1-R text-[1F1D1F]"> ไม่พบข้อมูล </span>
      </div>
      </div>
      <div class="w-full h-[1px] bg-[#B7B2B5]"></div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  forToday: {
    type: Boolean,
    default: true,
  },
  editAble: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["team-modal"]);

const openTeamInfoModal = (id) => {
  emit("team-modal", props.item, id);
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>